module.exports = __webpack_public_path__ + "static/8-81323ed88b48a953b85b61f5cbfa0cfa.png";